/**
 * @file     forms.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for all form fields, validation messages, and per-form-type success/error copy.
 */
export const forms = {
  validation: {
    nameRequired: 'Please enter your name',
    emailRequired: 'Please enter a valid email',
    phoneRequired: 'Please enter a valid phone number',
    addressRequired: 'Please enter the property address',
    consentRequired: 'Please agree to the contact terms to continue.',
    requiredFields: 'Complete the highlighted fields and then submit.'
  },
  global: {
    submitError: 'That did not work. Try again.',
    intro: '',
    privacy: 'Your details are only used to follow up with you.',
    emailHelper: '',
    phoneHelper: 'Optional.'
  },
  buyer: {
    title: 'Share what you are planning',
    nameLabel: 'Name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Email',
    emailPlaceholder: 'name@email.com',
    phoneLabel: 'Phone',
    phonePlaceholder: '(604) 555-0123',
    timelineLabel: 'Buying timeline',
    timeline: {
      asap: 'ASAP',
      zeroToThree: '0-3 months',
      threeToSix: '3-6 months',
      researching: 'Researching'
    },
    successMessage:
      'Thanks, {{name}}. Your resource is on the way.'
  },
  seller: {
    addressLabel: 'Address',
    addressPlaceholder: '123 Main St, Vancouver',
    emailLabel: 'Email',
    emailPlaceholder: 'name@email.com',
    phoneLabel: 'Phone',
    phonePlaceholder: '(604) 555-0123',
    timelineLabel: 'Selling timeline',
    timeline: {
      asap: 'ASAP',
      oneToThree: '1-3 months',
      threeToSix: '3-6 months',
      sixPlus: '6+ months'
    },
    successMessage:
      'Request received. Your home value overview will follow.'
  },
  landlord: {
    addressLabel: 'Rental property address',
    addressPlaceholder: '123 Main St, Vancouver',
    emailLabel: 'Email',
    emailPlaceholder: 'name@email.com',
    phoneLabel: 'Phone',
    phonePlaceholder: '(604) 555-0123',
    timelineLabel: 'Tenant placement timeline',
    timeline: {
      asap: 'ASAP',
      twoToFourWeeks: '2-4 weeks',
      oneToTwoMonths: '1-2 months',
      planningAhead: 'Planning ahead'
    },
    successMessage:
      'Request received. Leasing next steps will follow.'
  },
  newsletter: {
    nameLabel: 'Name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email',
    emailPlaceholder: 'name@email.com',
    subtitle: 'A short weekly market update.',
    reassurance: 'No spam. Unsubscribe anytime.',
    successMessage: 'Thanks, you are on the list.'
  },
  dealFinder: {
    successMessage: 'Thanks, {{name}}. Matching homes will be sent to you.',
    missingQualification: 'Please complete the qualification steps first.'
  },
  leadMagnetLabel: 'Free resource',
  realtor: {
    question: 'Are you working with a REALTOR®?',
    yes: 'Yes',
    no: 'No',
    required: 'Choose Yes or No.',
    yesShowing: 'The REALTOR® you work with can also book this for you.',
    yesOffer: 'The REALTOR® you work with can also send this offer for you.',
    yesDocuments: 'The REALTOR® you work with can also get these for you.',
  },
  consent: {
    continuing: 'continuing',
    terms: 'By {{action}}, you agree to the <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.',
    smsOptIn: 'Text me about this request. Frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help.',
    emailOptIn: 'Email me market updates, new listings, and news about Relta tools and services.',
    contactOptIn:
      'Email or text me new listings, market updates, and news about Relta tools and services. Frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help.',
    identity:
      'From Ray Rasouli, Real Broker B.C. Ltd., {{mailingAddress}} · ray@relta.ca. You can withdraw consent any time by unsubscribing or replying STOP.',
    settingsTitle: 'Email updates',
    settingsLabel: 'Email me market updates, new listings, and news about Relta tools and services.',
    settingsHelper: 'You can turn this off any time.',
    settingsError: 'That change did not save. Try again.',
    choicesLabel: 'Your contact choices',
  },
  smsCompliance: {
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
  },
  contact: {
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email',
    phoneLabel: 'Mobile phone',
    phonePlaceholder: '(604) 555-0123',
    phoneReasonCall: 'For a call about your questions.',
    firstNameRequired: 'Enter your first name.',
    lastNameRequired: 'Enter your last name.',
    emailInvalid: 'Enter an email address, like name@example.com.',
    phoneInvalid: 'Enter a 10-digit mobile number.',
    continue: 'Continue',
  },
} as const;
